import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M1780 5060c0-20 29-68 45-74 28-10 60-7 83 10 20 14 24 14 44 0 45-32 98-14 118 39 12 33 5 46-13 22-27-36-98-38-119-4-5 8-12 6-26-6-27-24-88-22-104 3-14 22-28 26-28 10" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.128 1081.267)" /><path d="M2752 4993c-10-19-49-156-102-357-56-215-95-306-195-462-75-115-82-131-89-194-6-50-25-605-42-1185-8-285-25-444-50-462s-30-17-70 20c-63 58-64 69-49 628 8 272 17 583 21 691l7 197-27 7c-33 8-65 3-234-37-98-24-136-37-143-51-14-26-31-737-27-1153 3-338 4-351 25-391 21-39 196-214 214-214 29 0-6-51-116-170-69-74-125-142-125-150s28-35 61-60 80-66 104-91c62-67 80-105 125-276l11-43h339l46 93c65 129 131 215 206 267 104 71 101 68 80 105-11 17-51 75-90 129-40 54-72 108-72 119s22 50 50 86c27 37 54 80 60 95 37 98 52 343 70 1171 6 253 15 609 20 790 25 911 25 961-8 898m-212-2123c-6-256-15-499-20-540-18-135-77-218-197-277l-54-26 17-26c9-14 24-35 34-46 43-50 180-237 180-245 0-5-17-24-37-42-90-80-149-171-203-314-24-63-36-84-48-82-25 5-32 62-26 210 6 127 8 139 30 159 31 29 48 88 35 122-12 31-82 61-122 52-68-15-94-118-44-177 24-29 25-34 25-178 0-134-11-213-26-197-3 3-12 43-20 89-22 129-76 218-177 293-54 40-77 63-77 77 0 5 42 54 93 110 50 55 114 125 140 154l48 53-68 35c-38 19-93 56-122 82-97 87-91 29-90 834 0 388 4 725 7 750l7 45 80 11c44 6 81 10 83 9 1-1-2-42-8-91-23-202-40-1246-21-1328 18-77 113-145 204-146 90 0 148 44 182 139 19 54 31 325 45 1006 5 281 12 539 15 575 5 60 11 73 73 165l67 100 3-445c2-245-2-654-8-910" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.127 1081.27)" /><path d="m1893 4951-33-27v-123c0-68 5-233 11-368 6-134 9-246 7-249-3-2-32 23-66 57-107 107-162 243-162 399 0 94 16 168 54 243l24 50-28-29c-48-48-97-140-115-215-49-200 25-411 188-534l67-50-43-12c-23-6-64-15-92-19l-50-7 45-9c25-5 78-7 118-4 53 4 72 3 72-7 0-6 9-23 19-37l19-24 21 24c11 14 20 31 21 38 0 10 13 12 55 7 30-4 81-4 112 0 53 8 56 9 28 16-16 5-57 14-90 20l-60 12 30 21c63 44 162 153 188 206 83 171 72 362-29 516-19 28-43 59-55 70-20 17-20 15 5-33 104-207 62-462-105-637l-68-71 6 377 6 376-29 26c-16 14-31 25-34 25s-20-12-37-28" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.118 1081.272)" /><path d="M2238 4896c165-177 200-432 88-643-19-35-30-63-25-63 19 0 112 106 139 160 115 228 14 496-225 596l-39 16z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.147 1081.272)" /><path d="M1605 4928c-227-118-303-403-165-618 28-43 108-125 116-117 1 1-13 34-31 72-43 87-55 143-55 248 0 148 50 277 148 379 58 61 54 71-13 36" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.108 1081.273)" /><path d="M3967 3855c-75-28-158-79-172-106-19-35-10-65 55-187 49-90 51-97 34-109-20-15-50-9-79 17-36 31-44 31-92-6-82-62-134-71-176-28-29 28-48 101-40 152 5 31 4 32-31 32-25 0-45 9-69 30-66 58-99 24-77-79l13-60-44-72c-47-78-72-171-63-229 3-19 25-96 49-170 62-192 61-180 18-241-61-89-60-101 47-499 79-293 98-494 71-767-10-99-21-185-25-191-5-9-114-12-412-12-222 0-404 3-404 6s13 25 30 49c63 92 235 222 350 266 36 14 100 22 226 31 208 14 221 31 22 31-156 1-223-14-339-74-100-52-195-132-271-227-84-106-109-172-72-186 9-4 594-9 1300-13l1284-6v40c0 54-15 96-64 175-33 54-47 68-71 72-16 3-129 8-250 11-411 11-625 35-918 106-180 43-266 50-138 10 276-85 656-139 1054-148l249-6 54-65c30-36 54-69 54-72 0-13-525-20-1071-13l-561 6 8 196c12 265 8 472-10 578-8 48-47 203-86 345-38 141-70 268-70 283 0 25 39 75 59 75 33 0 86-188 126-450 39-262 48-394 42-648-2-128-3-232-1-230s13 58 25 123c30 157 29 387 0 632-22 176-31 227-76 438-31 145-30 165 10 178 67 21 82 58 40 97l-25 24 32 33c46 48 66 41 106-34 36-68 50-75 101-48 26 13 34 13 75-1 36-13 53-14 78-5 42 15 100 14 122-2 10-8 28-34 40-58 18-39 25-44 57-47 55-5 124 32 170 90 34 43 39 57 39 101 0 103-62 162-100 95-22-40-4-64 42-60 45 4 52-12 28-65-34-77-130-133-190-111-38 13-38 27 0 63 28 27 31 34 28 87-3 66-23 75-23 11 0-49-13-66-46-61-21 3-24 8-22 46l2 43-62-3c-55-3-62-5-65-25-2-14 3-23 17-28 32-10 25-21-19-34-70-21-87-1-117 136-9 40-20 73-25 73s-6-39-2-94l7-94-28-18c-41-27-76-4-92 58-19 79-30 84-99 43-36-21-50-39-79-100-20-41-40-75-45-75s-37 71-72 158c-60 150-63 161-63 243 0 78 3 90 30 135 47 76 109 70 71-7-22-44-20-81 5-108 19-20 23-21 36-8 8 8 19 50 24 93 6 43 13 81 16 84s17-11 32-30c73-96 96-100 193-35 37 25 70 45 74 45 3 0 19-11 36-25 51-43 109-29 134 31 17 40 11 74-24 126-27 41-24 68 8 68 31 0 14 18-28 30-90 25-82 54 28 104 148 68 209 56 197-36l-6-43 24 50c30 60 31 77 7 98-23 21-110 22-165 2m-583-257c8-13 7-21-1-29-16-16-43 5-43 33 0 24 28 21 44-4m41-218c9-15-16-43-27-32-10 10 0 42 12 42 5 0 12-5 15-10" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.163 1081.325)" /><path d="M1495 3821c-59-27-287-164-341-205-26-20-52-36-59-36s-16 19-19 45c-4 26-13 45-20 45-12 0-93-54-163-108-54-42-145-161-189-245-21-42-42-77-45-77s-12 21-20 47c-23 75-41 78-101 13-71-76-141-186-169-265-13-37-29-70-36-72-7-3-30 9-52 26-21 17-41 31-44 31-7 0-56-129-73-193-8-28-14-75-14-103 0-61-9-114-20-114-5 0-32 16-61 36l-53 36-10-28c-21-65 30-295 102-460l40-89-27-8c-14-5-32-10-39-13-27-8 86-178 161-239 18-15 58-52 90-83l58-56-35-18c-20-10-36-26-36-35 0-21 67-85 126-119 67-39 162-72 232-80 60-6 61-7 47-27-8-12-15-24-15-28 0-9 106-55 160-69 32-9 102-10 245-5 222 7 257 1 320-53 30-27 38-29 158-35 147-8 313 1 326 17 15 18-4 102-32 145-58 88-185 176-442 305-215 109-305 167-389 252-79 80-129 174-162 301-47 185-43 308 15 543 65 264 273 584 595 917l118 123h-43c-24 0-62-9-84-19m-95-121c0-19-22-49-222-303-161-205-289-435-327-587-50-201-61-358-37-515 25-161 80-268 198-382 86-82 195-151 433-273 273-141 352-199 385-285l10-27-222 4c-197 3-227 5-254 22-26 16-37 17-63 8-28-10-31-9-31 9 0 23-26 25-77 4-22-9-49-13-68-9-19 3-35 1-39-5-11-17-29-13-22 4 4 12-3 11-34-5-22-11-40-17-40-13 0 15-75 35-126 33-39-1-54 4-68 19-18 20-18 21 5 29 28 11 375 42 464 42 56 1 59 2 40 16-15 12-36 15-88 11-37-2-70-1-72 4-3 4-18 4-35-1-16-4-46-6-68-3-27 4-47 0-66-12-25-17-26-17-26 4 0 23-10 27-27 10-7-7-17-8-30-1-14 8-25 6-43-9-32-24-39-24-33 1 6 23 0 25-29 9-17-9-23-8-30 5-7 12-14 14-28 6-10-5-33-10-50-10-23 0-33 6-42 25-11 24-13 24-34 10-31-20-44-19-44 5 0 17-4 18-25 10-20-7-25-6-25 5 0 8-8 15-18 15-18 0-112 55-112 65 0 3 15 12 34 20 34 14 184 9 443-15 57-5 113-6 125-1 16 6 2 9-52 14-40 3-78 11-84 17-5 5-21 10-34 10s-53 8-88 17c-52 14-68 15-84 5-18-11-20-10-20 9 0 16-4 19-18 14-9-5-33-10-52-13-29-3-33-2-22 9 20 22 14 29-18 17-27-9-34-7-65 21-20 17-42 31-50 31s-19 9-25 19c-5 11-22 21-37 23-20 2-28 8-27 21 1 10-7 19-22 23-13 3-26 14-29 24-3 11-14 22-24 25-19 6-71 73-71 92 0 6 6 16 14 22 19 16 69-5 200-84 105-63 251-127 316-139 39-7 38-6-50 49-30 19-74 43-96 54-23 11-45 24-48 30-4 6-26 11-48 11h-41l22 24 23 24-64 14c-55 12-63 16-63 36 0 26-29 52-57 52-10 0-21 7-25 15-3 9-19 23-36 32-29 14-29 16-13 29 16 12 16 14-13 29-32 16-39 31-19 37 19 7 2 35-31 49-34 15-39 27-16 35 21 8 19 39-3 61-23 23-39 64-47 126-6 45-5 47 18 47 37 0 72-33 92-87 67-178 159-295 318-402 43-29 107-56 107-46 0 2-26 22-58 44-32 21-64 47-72 56-8 10-32 29-54 43-37 23-39 25-21 38 22 16 24 15-42 48-57 28-65 42-33 54 18 7 14 11-27 32-42 21-45 24-24 28 22 3 21 5-15 28l-39 23 33 1c41 0 41 14-4 55-31 28-33 34-19 42s13 12-7 38c-15 19-18 30-10 33 8 2 6 12-9 33l-20 29h54l-21 23c-27 29-28 41-2 34 18-5 19-3 5 24-21 39-19 52 5 44 18-6 20-3 14 19-4 15-1 32 6 41 7 8 10 22 6 30-9 24 4 45 29 45 27 0 29-6 74-185 17-66 37-140 46-165 21-58 104-200 122-207 24-9 26 4 5 34-11 15-26 55-32 88s-20 72-31 87c-23 33-24 38-4 38 12 0 13 4 5 19-5 11-10 28-10 39 0 10-13 34-30 52-16 18-30 36-30 39s12 18 27 33l27 28h-26c-26 0-38 20-38 62 0 15 4 16 25 8s25-7 25 9c0 10-9 26-20 36-22 20-28 75-7 75 7 0 19-6 26-12 8-8 6 1-4 21-17 33-17 34 4 28 18-4 21-1 21 22 0 15 4 31 8 37 5 5 14 28 20 50 8 27 29 58 60 88l47 46 14-32c17-38 19-153 7-344-9-134-1-248 15-209 4 11 8 77 8 148 1 110 4 130 19 145 13 13 18 29 14 50-2 17 1 47 8 67 12 35 13 36 31 19 23-21 23-18 4 36-16 45-13 60 11 60 9 0 14 10 14 27 0 21 3 24 12 15 22-22 30-13 23 27-7 42 6 61 29 42s49 21 44 69c-4 45 3 50 27 18 16-23 16-22 10 13-7 36 13 68 33 55 6-3 12 4 15 15 4 13 11 20 20 16 9-3 20 7 30 28 15 31 51 54 64 41 12-11-20-122-63-223-48-111-51-125-30-117 18 7 110 141 123 180 21 62 64 113 147 178 73 57 154 105 179 106 4 0 7-9 7-20" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.042 1081.326)" /><path d="M3295 3766c-13-13-35-47-50-76l-27-52-34 33c-34 33-34 33-34 9 0-14 16-49 37-78l36-53 24 76c21 65 29 79 59 97 24 14 34 27 34 44 0 30-14 30-45 0" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.194 1081.329)" /><path d="M3646 3761c-17-17-41-31-59-33l-29-3 18-23 19-23 48 55c50 58 52 78 3 27" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.214 1081.329)" /><path d="M4232 3759c-50-37-76-100-50-125 11-12 21-13 42-4 15 5 38 10 52 10 28 0 30 8 10 35-14 19-15 19-34 2-10-10-26-15-35-11-32 12-25 34 25 79 57 52 52 60-10 14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.243 1081.329)" /><path d="M3976 3644c-20-20-20-19 6-44 27-25 35-25 48 1 9 16 8 25-6 40-21 23-28 24-48 3" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.233 1081.335)" /><path d="M4206 3510c-61-46-102-48-158-8-13 10-20 10-29 1s-8-22 5-53c25-64 21-91-21-132-51-49-99-68-177-68-36 0-67-4-70-8-8-13 97-46 125-39 53 14 118 66 161 131 44 67 128 134 172 139 17 2 21-3 21-25-1-43 17-16 22 35 3 24 1 47-4 50-4 3-26-8-47-23" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.223 1081.341)" /><path d="M3524 3285c-15-11-17-17-8-32 14-23 41-28 70-13 19 11 25 10 39-4 19-19 37-20 53-4 32 32-12 70-55 47-20-11-28-10-52 4s-31 15-47 2" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.211 1081.353)" /><path d="M4076 3261c-16-11-34-27-39-37-8-14-5-14 20 4 28 20 60 52 52 52-2 0-17-9-33-19" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.237 1081.353)" /><path d="M4265 3241c-16-10-39-28-50-41l-20-23 30 16c26 13 86 67 74 67-2 0-17-8-34-19" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.244 1081.354)" /><path d="M3388 3193c-2-28-9-41-28-51-24-13-23-13 17-8 59 8 113 36 113 58s-29 38-69 38c-27 0-30-3-33-37" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.203 1081.356)" /><path d="M4055 3171c-3-6-21-11-39-11-41 0-63-21-42-39 12-10 20-10 38 1 13 7 37 13 53 13 23 0 30 5 30 20 0 21-29 33-40 16" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.233 1081.358)" /><path d="M3706 2778c-10-6-38-10-62-10-49 1-60-18-21-35 31-14 132-27 146-18 8 4 6 15-4 34-17 34-35 42-59 29" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.216 1081.377)" /><path d="M3704 2621c4-19 12-53 18-75 10-35 12-37 16-17 5 34-6 84-24 107-15 18-15 17-10-15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.22 1081.384)" /><path d="M1976 1133q-16.5-16.5 15-90c26-58 35-44 19 32-11 54-21 71-34 58" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.137 1081.457)" /><path d="M2210 1116c0-14 6-43 14-63 8-21 17-47 19-58 3-11 5 1 6 27 1 39 6 51 26 64 33 21 32 39-2 40-16 0-36 4-45 8-15 7-18 3-18-18" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.149 1081.457)" /><path d="M2395 1108c-18-21-25-38-21-53 3-13-4-35-20-58-13-20-22-37-20-37 3 0 37 25 76 56 66 54 88 80 55 68-19-8-65 3-65 15 0 5 11 12 25 15 14 4 23 11 20 16-10 17-22 11-50-22" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.155 1081.457)" /><path d="M2060 1110c0-8 11-44 25-80l24-65v63c1 62 1 62 30 62 24 0 41 14 41 36 0 2-27 2-60 1-46-1-60-6-60-17" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1928 0 0 -.1928 8.142 1081.457)" /></svg>;
export default Component;
export { Component as ReactComponent };